import buttonFactoryV3 from './reducerButtonFactoryV3';
import application from './reducerApplication';
import partnerButtons from '../componentsV3/partner/reducerPartner';
import buttonManagerV3 from '../componentsV3/buttonManager/reducerManager';
import campaigns from './reducerCampaigns';
import { reducer as reduxFormReducer } from 'redux-form';

const customReducer = (state = {}, action) => {
  const businessImageUrls = state?.application?.businessImageUrls;
  const merchantExperienceUrls = state?.application?.merchantExperienceUrls;
  const userType = state?.application?.userType;
  return {
    application: application(state.application, action),

    buttonFactoryV3: buttonFactoryV3(state.buttonFactoryV3, {
      ...action,
      businessImageUrls,
      merchantExperienceUrls,
      userType,
    }),
    buttonManagerV3: buttonManagerV3(state.buttonManagerV3, {
      ...action,
      businessImageUrls,
      merchantExperienceUrls,
    }),
    partnerButtons: partnerButtons(state.partnerButtons, action),
    campaigns: campaigns(state.campaigns, action),
    form: reduxFormReducer(state.form, action),
  };
};

export default customReducer;
